import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

export default function NewServiceCard({
  firstImage,
  title,
  subtitle,
  secondImage,
  onClick,
  textColor
}) {
  return (
  <>
<Box 
      sx={{ 
        position: "relative", // Make this the reference for absolute positioning
       
       
        cursor: "pointer"
      }}
      onClick={onClick}
    >
      <Grid container alignItems="center"  p={2}>
        {/* Optional first image */}
        {/* <Grid item xs={12} sm={1.8}>
          <Box sx={{ height: "40px", width: "40px" }}>
            <img src={firstImage} height="100%" width="100%" />
          </Box>
        </Grid> */}

        <Grid item xs={12} >
          <Box display="flex" alignItems="center" justifyContent="space-between" >
          <Typography
            sx={{
              fontSize: "16px",
              fontWeight: 700,
              fontFamily: "Inter",
              color: textColor,
            }}
          >
            {title}
          </Typography>

            <ChevronRightIcon style={{zIndex:1}}/>
            </Box>
               </Grid>
               <Grid item xs={10}>
          <Typography
            mt={1}
            sx={{
              fontSize: "12px",
              fontWeight: 500,
              fontFamily: "Inter",
              fontStyle: "normal",
              color: "#444444",
              
            }}
          >
            {subtitle}
          </Typography>
          </Grid>
     

      
        
      </Grid>

      {/* Absolute element */}
      <Box
        sx={{
          position: "absolute",
          right: 0, // spacing from right
          bottom: 0, // spacing from bottom
          display: "flex",
          alignItems: "center",
          gap: "4px",
        }}
      >
        {secondImage && (
          <Box sx={{ width: "80px" }}>
            <img src={secondImage} height="100%" width="100%" />
          </Box>
        )}
       
      </Box>
    </Box>
     
  </>
   
  );
}
